const { IS_SSR } = require('../../constants');

const serverRenderIf = (condition) => (IS_SSR ? condition : true);

module.exports = serverRenderIf;
